/** Tier 1 Step 8 — frozen DK v1.0 relative paths (T1-D-010 §13). */
export const Tier1DepartureKitRelativePaths = [
    "departure-kit/README.md",
    "departure-kit/manifest.json",
    "departure-kit/businessgraph-snapshot.json",
    "departure-kit/content/content.json",
    "departure-kit/content/content.csv",
    "departure-kit/assets/asset-manifest.json",
    "departure-kit/artifact-index.json",
    "departure-kit/approval-records/approval-records-sanitized.json",
    "departure-kit/quality-gate-result.json",
    "departure-kit/reports/search-readiness-report.json",
    "departure-kit/reports/search-readiness-client-safe.json",
    "departure-kit/reports/launch-proof-report.json",
    "departure-kit/reports/launch-proof-client-safe.json",
    "departure-kit/guides/HANDOFF_GUIDE.md",
    "departure-kit/guides/DNS_HOSTING_TRANSFER.md",
    "departure-kit/guides/DEVELOPER_README.md",
    "departure-kit/guides/AGENCY_TRANSFER_EMAIL_TEMPLATE.md",
    "departure-kit/connected-accounts-summary.json",
    "departure-kit/evidence/evidence-references.json",
];
/** Written only when latest passing ≠ latest approved artifact. */
export const Tier1DepartureKitMismatchNoticePath = "departure-kit/MISMATCH_NOTICE.md";
export const TIER1_DK_SCHEMA_VERSION = "tier1-departure-kit.v1.0";
//# sourceMappingURL=tier1-departure-kit-paths.js.map